import React, { createContext, useEffect, useRef, useState } from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";
import { getInventoryList } from "../Services/InventoryConfigurationService";

const InventoryManagementContext = createContext();

const InventoryManagementProvider = ({ children }) => {
  const [partList, setPartList] = useState([]);
  const [filters, setFilters] = useState({ dropdowns: {}, txt: {} });
  const [loadingParts, setLoadingParts] = useState(true);
  const [maxPages, setMaxPages] = useState(null);
  const [navigateBatch, setNavigateBatch] = useState(null);
  const [page, setPage] = useState(0);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [tabIndexForce, setTabIndexForce] = React.useState(0);
  const [countSearch, setCountSearch] = useState({});
  const [search, setSearch] = useState("");
  const [updateFromPartIssue, setUpdateFromPartIssue] = useState(null);

  const [sortingOrder, setSortingOrder] = useState("part_number");
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const pageSize = 10;
  const onFiltersChange = (dropdownFilters, txtFilters) => {
    setFilters({
      dropdowns: dropdownFilters,
      txt: txtFilters,
    });
  };
  const onSearch = (value) => {
    setSearch(value);
  };

  const didMount = useRef(false);

  const dropdownColumnMap = {
    1: "part_id",
    2: "category_id",
    3: "subCategory_id",
    11: "ata_chapter_id",
    12: "ata_section_id",
    13: "ata_paragraph_id",
    87: "location_id",
    102: "site_id",
    88: "aircraft_id",
    126: "part_condition_id",
  };
  useEffect(() => {
    window.addEventListener("keydown", handleEnterKey);
    return () => {
      window.removeEventListener("keydown", handleEnterKey);
    };
  }, []);
  const handleEnterKey = (event) => {
    if (event.ctrlKey && event.key === "l") {
      setUpdateFromPartIssue(new Date().getTime());
    }
  };
  useEffect(() => {
    setLoadingParts(true);
    setPage(0);
    getInventoryList(
      0,
      pageSize,
      tabIndex,
      filters,
      dropdownColumnMap,
      search,
      sortingOrder
    )
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => ({
            ...item,
            type: item.serial_number != null ? "part" : "consumable",
            status:
              item.aircraft_id != null
                ? "Installed"
                : item.quantity > 0
                ? "Available"
                : "Issued",
            isPartialIssued: item.issued_transactions > 0,
          }));
          setCountSearch(response.data.auxiliarInformation);
          let tabView = 0;
          for (let i = 1; i < 6; i++) {
            let countInfo = response.data.auxiliarInformation["countView" + i];
            if (countInfo > 0) {
              tabView = i;
              break;
            }
          }
          if (search !== "" && tabView > 0) {
            setTabIndexForce(tabView);
          }

          setPartList((prev) =>
            page > 0 ? [...prev, ...inventoryArray] : [...inventoryArray]
          );
          setLoadingParts(false);
        }
      })
      .catch((error) => setLoadingParts(false));
  }, [filters, tabIndex, search, updateFromPartIssue]);

  useEffect(() => {
    getInventoryList(
      page,
      pageSize,
      tabIndex,
      filters,
      dropdownColumnMap,
      search,
      sortingOrder
    )
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => ({
            ...item,
            type: item.serial_number != null ? "part" : "consumable",
            status:
              item.aircraft_id != null
                ? "Installed"
                : item.quantity > 0
                ? "Available"
                : "Issued",
            isPartialIssued: item.issued_transactions > 0,
          }));
          setCountSearch(response.data.auxiliarInformation);
          let tabView = 0;
          for (let i = 1; i < 6; i++) {
            let countInfo = response.data.auxiliarInformation["countView" + i];
            if (countInfo > 0) {
              tabView = i;
              break;
            }
          }
          if (search !== "" && tabView > 0) {
            setTabIndexForce(tabView);
          }
          setPartList((prev) =>
            page > 0 ? [...prev, ...inventoryArray] : [...inventoryArray]
          );
          setLoadingParts(false);
        }
      })
      .catch((error) => setLoadingParts(false));
  }, [page, sortingOrder]);
  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };

  return (
    <InventoryManagementContext.Provider
      value={{
        onFiltersChange,
        partList,
        requestNextPage,
        loadingParts,
        onSearch,
        setTabIndex,
        tabIndex,
        tabIndexForce,
        navigateBatch,
        setNavigateBatch,
        setSortingOrder,
        countSearch,
        setUpdateFromPartIssue,
      }}
    >
      {children}
    </InventoryManagementContext.Provider>
  );
};

export { InventoryManagementContext, InventoryManagementProvider };
